import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import axios from 'axios';
// import Turnstile from 'react-turnstile';
import './Auth.css';

const Login = ({ setAuth }) => {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    // const [captchaToken, setCaptchaToken] = useState(null);
    // const [captchaLoaded, setCaptchaLoaded] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    
    // Comment out CAPTCHA related code
    // const SITE_KEY = process.env.REACT_APP_CLOUDFLARE_SITE_KEY || "0x4AAAAAABAMwgSnbk3flmdF";
    
    // More reliable environment detection
    // const isDevelopment = true; // Force development mode to bypass CAPTCHA
    // const isDevelopment = 
    //     window.location.hostname === 'localhost' || 
    //     window.location.hostname === '127.0.0.1';

    useEffect(() => {
        // Check if there's a message from the signup page
        if (location.state?.message) {
            setMessage(location.state.message);
        }
        
        // Comment out CAPTCHA related code
        // In development, set a default token
        // if (isDevelopment) {
        //     setCaptchaToken('development-token');
        // }
    }, [location]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        // Comment out CAPTCHA verification
        // Only check for CAPTCHA in production
        // if (!isDevelopment && !captchaToken) {
        //     setError('Please complete the CAPTCHA verification');
        //     return;
        // }

        try {
            const response = await axios.post('/api/login', {
                ...formData,
                // captchaToken,
                isDevelopment: true // Always send development flag to bypass server CAPTCHA check
            });

            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify(response.data.user));
            
            setAuth({
                isAuthenticated: true,
                user: response.data.user
            });
            
            navigate('/dashboard');
        } catch (err) {
            setError(err.response?.data?.error || 'Login failed. Please check your credentials.');
            
            // Comment out CAPTCHA reset
            // Reset CAPTCHA on error if in production
            // if (!isDevelopment && window.turnstile) {
            //     window.turnstile.reset();
            //     setCaptchaToken(null);
            // }
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h2>Login</h2>
                {error && <div className="error-message">{error}</div>}
                {message && <div className="info-message">{message}</div>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    
                    {/* CAPTCHA component commented out */}
                    
                    <button type="submit" className="auth-button">Login</button>
                </form>
                <p className="auth-link">
                    Don't have an account? <Link to="/signup">Sign up</Link>
                </p>
            </div>
        </div>
    );
};

export default Login;